const SHIPPER_INFO = [
  {
    key: 'montway',
    to: 'vip@montway.com',
    cc: '',
    name: 'Montway Auto Transport',
    logo: {
      name: 'montway.png',
      alt: 'Montway Logo',
    },
  },
  {
    key: 'jackcooper',
    to: 'relocation@jackcooper.com',
    cc: 'mmaggiore@jackcooper.com',
    name: 'Jack Cooper Transport',
    logo: {
      name: 'jack-cooper.png',
      alt: 'Jack Cooper Logo',
    },
  },
];

let selectedShipper;

const randomElement = array => array[Math.floor(Math.random() * array.length)];
export const fallbackGetAutoShipper = () => {
  if (!selectedShipper) {
    selectedShipper = randomElement(SHIPPER_INFO);
  }
  return selectedShipper;
};
